import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Injector,
  Input,
  OnDestroy,
  OnInit,
  Optional,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SuggestionType, UserTemplateSuggestionInputInterface } from '@app/shared/component/common-suggestion-view/suggestion';
import { SharedConfirmationDialogComponent } from '@app/shared/component/shared-confirmation-dialog/shared-confirmation-dialog.component';
import { DocumentService, UserService } from '@app/shared/services';
import { Observable, Subscription, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { EVENTS } from '@app/constants/events.constants';
import { ManageElementFilterConfigurationType } from '@app/shared/component/manage-element/manage-combo-element/manage-element.inteface';
import { ConfigurationType } from '@app/shared/component/manage-element/manage-combo-element/enum';
import { GetFileExtension } from '@app/shared/pipes/get-file-extension.pipe';
import { FileNameWithoutExtension } from '@app/shared/pipes/file-name-without-extension.pipe';
import { ConnectToMxComponent } from '@app/modules/vault/mx-component/dialog/connect-to-mx/connect-to-mx.component';
import { EditMxPlayerComponent } from '../../add-api-key-managed/edit-mx-player/edit-mx-player.component';
import { AddDocumentComponent } from '../../add-document.component';
import { MxTaskbarService } from '@app/shared/services/mx-taskbar/mx-taskbar.service';
import { LinkedTemplateListComponent } from './linked-template-list/linked-template-list.component';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'edit-add-linked-template-popup',
  templateUrl: './edit-add-linked-template-popup.component.html',
  styleUrl: './edit-add-linked-template-popup.component.scss',
  providers: [FileNameWithoutExtension, GetFileExtension],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditAddLinkedTemplatePopupComponent implements OnInit, OnDestroy {
  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data,
    private _documentService: DocumentService,
    private dialog: MatDialog,
    private injector: Injector,
    private renderer: Renderer2,
    private mxTaskbarService: MxTaskbarService,
    private getFileExtension: GetFileExtension,
    private fileNameWithoutExtension: FileNameWithoutExtension,
    private cd: ChangeDetectorRef,
    private _userService: UserService,
    private formBuilder: FormBuilder
  ) {}
  myForm = new FormGroup({
    name: new FormControl(false),
  });

  dialogRef;
  @Input() inlineComponent = false;
  @Input() inlinedata;
  @Input() hideCheckbox = true;
  @Input() isRemoveEditSaveSharing = false;
  @Input() isEditLinkFile = false;
  @Input() isFromLinkedTemplate = false;
  @Output() linkedTemplateSelectionChange = new EventEmitter<{
    template: any;
    index: number;
    isChecked: boolean;
  }>();
  @ViewChild('commonSuggestionViewContainer') commonSuggestionViewContainer!: ElementRef;
  @ViewChild(LinkedTemplateListComponent) linkedTemplateListComponent: LinkedTemplateListComponent;
  open_mx_popup = false;
  securityStateObject;
  vault_user_form_uploads_id;
  formTypeData = [];
  linkedLocation = false;
  getLinkedLocation = false;
  selectedItemsArray = [];
  swapFormIDWIthAssociate = false;
  allowedOne = false;
  requestsUserAccount = [];
  index = 0;
  screenWidth: number;
  loadingItems = [{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }];
  suggestionData: UserTemplateSuggestionInputInterface[] = [];
  subscription = new Subscription();
  title = 'Suggestions ';
  findItemSetup;
  title_type = '';
  hideMarkForCheck = false;
  templateConfigurationList;
  textBoxPlaceHolder = '';
  linkedTemplate = [];
  is_Group = false;
  group_templateConfigurationList = [];
  is_LinkedFileLoading = true;
  is_unLinkedFileLoading = true;
  unlinkedTemplate = [];
  filterConfiguration: ManageElementFilterConfigurationType[] = [];
  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this._userService.cleanupWorker();
  }
  addMXEventEmitter(event) {
    this.open_mx_popup = true;
    const dialogRef: MatDialogRef<ConnectToMxComponent> = this.mxTaskbarService.openMxDialog(ConnectToMxComponent, {
      width: '400px',
      maxWidth: '90vw',
      autoFocus: false,
      data: {
        formName: this.data?.formName,
        mx_connected_clients: [],
        title: 'Financial Institution',
        enable_linking: true,
        allowedOne: this.allowedOne,
        currentFormId: this.data.currentFormId,
        type_template: this.data.type_template,
        currentValutUserId: this.data.currentuserId,
      },
    });
    this.subscription.add(
      dialogRef.componentInstance.mxDialogMinimized.subscribe((dialogId: string) => {
        this.open_mx_popup = false;
        this.cd.detectChanges();
      })
    );
    this.subscription.add(
      dialogRef.afterClosed().subscribe((val) => {
        if (val.success && val?.userAccounts?.length) {
          this.createLinkedCheckFile(val?.userAccounts);
        } else {
          this.open_mx_popup = false;
          this.ngOnInit();
        }
        this.cd.detectChanges();
      })
    );
  }
  setAllowedOne() {
    if (this.data.allowedOne?.length) {
      let setAllowedOne = false;

      this.data.allowedOne.forEach((element) => {
        try {
          let root_form_type_template = this.data.root_form_type_template?.toLowerCase();
          let key = element.key.toLowerCase();
          if (root_form_type_template.indexOf(key) >= 0) {
            setAllowedOne = element.value;
          }
        } catch (error) {}
      });

      return setAllowedOne;
    } else {
      return this.data.allowedOne == false || this.data.allowedOne == null ? false : true;
    }
  }
  ngOnInit(): void {
    this.screenWidth = window.innerWidth;
    if (this.inlineComponent) {
      this.data = this.inlinedata;
      if (this.isFromLinkedTemplate) {
        this.loadingItems.length = 1;
      }
    } else {
      this.dialogRef = this.injector.get(MatDialogRef<EditAddLinkedTemplatePopupComponent>);
    }
    this.selectedItemsArray = this.data?.selectedItemsArray ? this.data?.selectedItemsArray : [];
    this.allowedOne = this.setAllowedOne();
    this.linkedLocation = this.data?.linkedLocation ? this.data?.linkedLocation : false;
    this.getLinkedLocation = this.data?.getLinkedLocation ? this.data?.getLinkedLocation : false;
    this.swapFormIDWIthAssociate = this.data?.swapFormIDWIthAssociate ? this.data?.swapFormIDWIthAssociate : false;

    this.vault_user_form_uploads_id = this.data?.vault_user_form_uploads_id ? this.data?.vault_user_form_uploads_id : null;
    this.title_type = this.data?.label;
    this.textBoxPlaceHolder = 'Search or Add New ' + this.data?.label;
    try {
      let template_list = this.data.template_list.map((x) => x.templateType);
      let list = this.data.formsList.filter((x) => template_list.includes(x.type));
      this.templateConfigurationList = list.map((x) => {
        let findTemplateType = this.data.template_list.find((item) => item.templateType == x.type);
        return {
          ...x,
          img: x.image,
          label: 'Create New ' + x.type,
          displayType: findTemplateType.templateSubType,
          isGroup: false,
          isCustomImg: true,
        };
      });
    } catch (error) {}
    this.getFormsList();
    this.getLinkedForms();
    this.subscription.add(
      this._documentService.getItemsToSetUpList(this.data.currentuserId, this.data.currentFormId).subscribe((res) => {
        if (this.data.label == 'Physical Location' || this.data.label == 'Password Location') {
          this.findItemSetup = res.find((x) => x.sub_type == (this.data.label == 'Password Location' ? 'Password' : 'Physical'));
        } else {
          this.findItemSetup = res.find((x) => x.sub_type == this.data.type);
        }

        if (this.findItemSetup) {
          this.myForm.controls.name.setValue(this.findItemSetup.status == 'created' ? false : true);
        } else {
          this.hideMarkForCheck = true;
        }
        this.cd.detectChanges();
      })
    );
  }

  onToggleChange(event: any): void {
    if (this.findItemSetup?.id) {
      this.subscription.add(
        this._documentService
          .updateItemsToSetUpList({
            id: this.findItemSetup.id,
            status: event.checked ? 'complete' : 'created',
            setupLabel: this.data?.label,
          })
          .subscribe((res) => {
            if (res && event.checked) {
              this.closeDialog();
            }
          })
      );
    }
  }

  selectItemEventEmitter(event) {
    this.selectConnectedUser(event.event);
  }

  onLinkedTemplateSelectionChange(event: { template: any; index: number; isChecked: boolean }) {
    this.linkedTemplateSelectionChange.emit(event);
  }

  processRequests(index) {
    if (index >= this.requestsUserAccount.length) {
      this.index = 0;
      this.requestsUserAccount = [];
      this.open_mx_popup = false;
      this.scrollToTop();
      this.ngOnInit();
      return;
    }
    if ((this.allowedOne || this.requestsUserAccount[index].checked) && this.requestsUserAccount[index].vault_user_form_id) {
      this.index = index;
      this.selectConnectedUser({ ...this.requestsUserAccount[index].vaultUserForm });
    } else {
      this.processRequests(index + 1);
    }
  }
  createLinkedCheckFile(userAccounts) {
    this.requestsUserAccount = this.allowedOne ? userAccounts : userAccounts.filter((x) => x.checked == true);
    this.index = 0;
    this.processRequests(0);
  }
  setlinkonly() {
    if (this.data.link_onlyOne == null) {
      return null;
    }
    let setLink_onlyOne = null;
    this.data.link_onlyOne.forEach((element) => {
      try {
        let root_form_type_template = this.data.root_form_type_template?.toLowerCase();
        let key = element.key.toLowerCase();
        if (root_form_type_template.indexOf(key) >= 0) {
          setLink_onlyOne = element.value;
        }
      } catch (error) {}
    });
    return setLink_onlyOne;
  }
  selectConnectedUser(event) {
    let link_onlyOne = this.setlinkonly();
    if (this.selectedItemsArray.length > 0) {
      let payload = {
        user_id: this.data.currentuserId,
        vault_user_form_id: this.selectedItemsArray.map((item) => item.vault_user_form_id),
        created_by_user_id: this.data.currentuserId,
        association_type: this.data.type_template,
        associate_vault_user_form_id: event.id,
      };
      if (this.vault_user_form_uploads_id != null) {
        payload['vault_user_form_uploads_id'] = this.vault_user_form_uploads_id;
      }

      if (this.swapFormIDWIthAssociate) {
        payload.vault_user_form_id = this.selectedItemsArray.map((item) => item.vault_user_form_id);
        payload.associate_vault_user_form_id = this.data.currentFormId;
      }
      this.subscription.add(
        this._documentService
          .deleteUserMultipleFormAssociation(
            this.data.currentuserId,
            this.selectedItemsArray.map((item) => item.vault_user_form_id),
            event.id
          )
          .subscribe((result) => {
            this.subscription.add(
              this._documentService.createUserFormAssociationMultiple(payload).subscribe(
                (res) => {
                  this.processRequests(this.index + 1);
                  const linkingType =
                    this.data.type == 'Physical Location'
                      ? 'physical_location'
                      : this.data.type == 'Password Location'
                      ? 'password_ocation'
                      : this.data.type;
                  this.trackEventsInMixPanel('add', linkingType, {
                    // form_name: res.form_name,
                    template_name: this.data.formName,
                    // vault_form_type: res.vault_form_type,
                    type_template: this.data.type_template,
                  });
                  if (this.requestsUserAccount.length == 0) {
                    this.getFormsList();
                    this.getLinkedForms();
                  }
                  this.scrollToTop();
                  this.cd.detectChanges();
                },
                (error) => {
                  this.processRequests(this.index + 1);
                  this.cd.detectChanges();
                }
              )
            );
            this.cd.markForCheck();
          })
      );
    } else {
      if (link_onlyOne != null) {
        let data = {
          user_id: this.data.currentuserId,
          vault_user_form_id: event.id,
          type: link_onlyOne,
        };
        this.subscription.add(
          this._documentService.getFormsLinked(data).subscribe(
            (res) => {
              if (res.data?.length == 0) {
                return this.precessSelectedConnectedUser(event);
              } else {
                const sharedDialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
                  width: '500px',
                  data: {
                    title: `Link ${this.data.label}`,
                    text: `${event?.form_name ? event?.form_name : event?.name} is currently held by ${
                      res.data[0].form_name
                    }. Would you like to link it to this instead?`,
                    proceedTitle: 'Yes, Change',
                    materialIcon: 'info',
                    showCancelBtn: true,
                  },
                });
                this.subscription.add(
                  sharedDialogRef.afterClosed().subscribe((confirmation) => {
                    if (confirmation) {
                      this.subscription.add(
                        this._documentService
                          .deleteUserFormAssociation(this.data.currentuserId, event.id, res.data[0].id, this.data?.vault_user_form_uploads_id)
                          .subscribe((result) => {
                            this.precessSelectedConnectedUser(event);
                            this.cd.markForCheck();
                          })
                      );
                    } else {
                      this.processRequests(this.index + 1);
                      this.is_LinkedFileLoading = false;
                      this.cd.detectChanges();
                    }
                  })
                );
              }
            },
            (error) => {
              this.processRequests(this.index + 1);
              this.is_LinkedFileLoading = false;
              this.cd.detectChanges();
            }
          )
        );
      } else {
        this.precessSelectedConnectedUser(event);
      }
    }
  }
  precessSelectedConnectedUser(event) {
    if (this.allowedOne && this.linkedTemplate.length > 0) {
      // <Institution template> is currently linked to <Account Template>. Would you like to link it to this instead?
      let text = `Are you sure you want to change the ${this.data.label} of ${this.data?.formName}`;
      if (event.form_name) {
        text = text + ` to ${event.form_name ? event.form_name : event.name}?`;
      }
      const sharedDialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
        width: '500px',
        data: {
          title: `Change ${this.data.label}`,
          text: text,
          proceedTitle: 'Yes, Change',
          materialIcon: 'info',
          showCancelBtn: true,
        },
      });
      this.subscription.add(
        sharedDialogRef.afterClosed().subscribe((confirmation) => {
          if (confirmation) {
            this.subscription.add(
              this._documentService
                .deleteUserFormAssociation(
                  this.data.currentuserId,
                  this.data.currentFormId,
                  this.linkedTemplate[0].linked_form_id,
                  this.data?.vault_user_form_uploads_id
                )
                .subscribe((result) => {
                  this.createFormAssociation(event);
                  this.cd.markForCheck();
                })
            );
          } else {
            this.processRequests(this.index + 1);
          }
        })
      );
    } else {
      this.createFormAssociation(event);
    }
  }
  createFormAssociation(event) {
    let payload = {
      user_id: this.data.currentuserId,
      vault_user_form_id: this.data.currentFormId,
      created_by_user_id: this.data.currentuserId,
      association_type: this.data.type_template,
      associate_vault_user_form_id: event.id,
    };
    if (this.vault_user_form_uploads_id != null) {
      payload['vault_user_form_uploads_id'] = this.vault_user_form_uploads_id;
    }

    if (this.swapFormIDWIthAssociate) {
      payload.vault_user_form_id = event.id;
      payload.associate_vault_user_form_id = this.data.currentFormId;
    }
    this.subscription.add(
      this._documentService.createUserFormAssociation(payload).subscribe(
        (res) => {
          this.processRequests(this.index + 1);
          const linkingType =
            this.data.type == 'Physical Location' ? 'physical_location' : this.data.type == 'Password Location' ? 'password_ocation' : this.data.type;
          this.trackEventsInMixPanel('add', linkingType, {
            // form_name: res.form_name,
            template_name: this.data.formName,
            // vault_form_type: res.vault_form_type,
            type_template: this.data.type_template,
          });
          if (this.requestsUserAccount.length == 0) {
            this.getFormsList();
            this.getLinkedForms();
          }
          this.scrollToTop();
          this.cd.detectChanges();
        },
        (error) => {
          this.processRequests(this.index + 1);
          this.cd.detectChanges();
        }
      )
    );
  }
  getLinkedForms() {
    // this.is_LinkedFileLoading = true;
    let sub_type = this.data.type;
    if (sub_type == 'Physical Location') {
      sub_type = 'Physical';
    } else if (sub_type == 'Password Location') {
      sub_type = 'Password';
    } else if (sub_type == 'Linked Payment Methods') {
      sub_type = 'PaymentMethod';
    }

    let data = {
      user_id: this.data.currentuserId,
      vault_user_form_id: this.data.currentFormId,
      type_template_list: this.data.template_list,
      type: this.data.type_template,
      vault_user_form_ids: this.selectedItemsArray.map((item) => item.vault_user_form_id),
      sub_type: sub_type,
    };
    if (this.vault_user_form_uploads_id != null) {
      data['vault_user_form_uploads_id'] = this.vault_user_form_uploads_id;
    }

    if (this.linkedLocation) {
      this.subscription.add(
        this._documentService.getFormsLinkingSearchItemTOSetupLocation(data).subscribe(
          (res) => {
            this.linkedTemplate = res;
            this.is_LinkedFileLoading = false;
            this.cd.detectChanges();
          },
          (error) => {
            this.is_LinkedFileLoading = false;
            this.cd.detectChanges();
          }
        )
      );
    } else if (this.getLinkedLocation) {
      if (this.selectedItemsArray.length > 0) {
        this.subscription.add(
          this._documentService.getFormsLinkedLocationMultipleForm(data).subscribe((res) => {
            this.linkedTemplate = res.data;
            this.is_LinkedFileLoading = false;
            this.cd.detectChanges();
          })
        );
      } else {
        this.subscription.add(
          this._documentService.getFormsLinkedLocation(data).subscribe(
            (res) => {
              this.linkedTemplate = res.data;
              this.is_LinkedFileLoading = false;
              this.cd.detectChanges();
            },
            (error) => {
              this.is_LinkedFileLoading = false;
              this.cd.detectChanges();
            }
          )
        );
      }
    } else {
      this.subscription.add(
        this._documentService.getFormsLinked(data).subscribe(
          (res) => {
            this.linkedTemplate = res.data;
            this.linkedTemplate.forEach((template) => {
              const matchTemplateExist = this.data.formsList.find((form) => form.type === template.vault_form_type);
              if (matchTemplateExist) {
                template.api_source = matchTemplateExist.api_source;
              }
            });
            this.is_LinkedFileLoading = false;
            this.cd.detectChanges();
          },
          (error) => {
            this.is_LinkedFileLoading = false;
            this.cd.detectChanges();
          }
        )
      );
    }
  }
  deleteTemplate(event) {
    let vault_user_form_uploads_id = this.data?.vault_user_form_uploads_id ? this.data?.vault_user_form_uploads_id : event.vault_user_form_uploads_id;
    if (this.selectedItemsArray?.length > 0) {
      this.subscription.add(
        this._documentService
          .deleteUserMultipleFormAssociation(
            this.data.currentuserId,
            this.selectedItemsArray.map((item) => item.vault_user_form_id),
            event.linked_form_id ? event.linked_form_id : event.formid
          )
          .subscribe((result) => {
            this.getFormsList();
            this.getLinkedForms();
            this.cd.markForCheck();
          })
      );
    } else {
      this.subscription.add(
        this._documentService
          .deleteUserFormAssociation(
            this.data.currentuserId,
            this.data.currentFormId,
            event.linked_form_id ? event.linked_form_id : event.formid,
            vault_user_form_uploads_id
          )
          .subscribe((result) => {
            const linkingType =
              this.data.type == 'Physical Location'
                ? 'physical_location'
                : this.data.type == 'Password Location'
                ? 'password_ocation'
                : this.data.type;
            this.trackEventsInMixPanel('remove', linkingType, {
              form_name: event.form_name,
              template_name: this.data.formName,
              vault_form_type: event.vault_form_type,
              type_template: this.data.type_template,
            });
            this.getFormsList();
            this.getLinkedForms();

            this.cd.markForCheck();
          })
      );
    }
  }

  deleteTemplateObservable(template: any): Observable<any> {
    let vault_user_form_uploads_id = this.data?.vault_user_form_uploads_id
      ? this.data?.vault_user_form_uploads_id
      : template.vault_user_form_uploads_id;
    return this._documentService
      .deleteUserFormAssociation(
        this.data.currentuserId,
        this.data.currentFormId,
        template.linked_form_id ? template.linked_form_id : template.formid,
        vault_user_form_uploads_id
      )
      .pipe(
        catchError((error) => {
          console.error(`Error deleting template "${template?.form_name || template?.id}":`, error);
          return of(null);
        })
      );
  }

  getFormsList() {
    const data = {
      user_id: this.data.currentuserId,
      vault_user_form_id: this.data.currentFormId,
      type_template_list: this.data.template_list.map((x) => x.templateType),
      type: this.data.type_template,
    };
    if (this.vault_user_form_uploads_id != null) {
      data['vault_user_form_uploads_id'] = this.vault_user_form_uploads_id;
    }

    if (this.linkedLocation) {
      this.subscription.add(
        this._documentService.getFormsLinkingSearchLocation(data).subscribe(
          (res) => {
            this.modifySuggestionData(res);
          },

          (error) => {
            this.is_unLinkedFileLoading = false;
            this.cd.detectChanges();
          }
        )
      );
    } else {
      this.subscription.add(
        this._documentService.getFormsLinkingSearch(data).subscribe(
          (res) => {
            this.modifySuggestionData(res);
          },

          (error) => {
            this.is_unLinkedFileLoading = false;
            this.cd.detectChanges();
          }
        )
      );
    }
  }
  handleSelectedUser(event) {
    if (event.event.origin == undefined || event.event.origin == null) {
      let payload = {
        user_id: this.data.currentuserId,
        associate_vault_user_form_id: this.data.currentFormId,
        vault_user_form_uploads_id: event.event.id,
        created_by_user_id: this.data.currentuserId,
        association_type: this.data.type_template,
        vault_user_form_id: event.event.formid,
      };
      this.subscription.add(
        this._documentService.createUserFormAssociation(payload).subscribe(
          (res) => {
            const linkingType =
              this.data.type == 'Physical Location'
                ? 'physical_location'
                : this.data.type == 'Password Location'
                ? 'password_ocation'
                : this.data.type;
            this.trackEventsInMixPanel('add', linkingType, {
              template_name: this.data.formName,
              type_template: this.data.type_template,
            });
            this.getFormsList();
            this.getLinkedForms();

            this.cd.detectChanges();
          },
          (error) => {
            this.cd.detectChanges();
          }
        )
      );
    } else {
      this.selectConnectedUser(event.event);
    }
  }
  modifySuggestionData(res) {
    this.unlinkedTemplate = res;
    this.suggestionData = [];
    this.formTypeData = [];
    if (this.linkedLocation) {
      if (this.data?.label == 'Items In This Location') {
        this.filterConfiguration = [];
        this.filterConfiguration.push({
          data: res.filter((x) => x.origin),
          key: ConfigurationType.TEMPLATE,
          label: 'Templates',
          placeHolder: 'Search Template',
          selectedData: this.linkedTemplate,
          templateConfigurationList: [],
        });
        let attachment_list = [];
        res.forEach((element) => {
          if (!element?.origin) {
            let newElement = {
              ...element,
              form_name: this.fileNameWithoutExtension.transform(element.display_file_name),
              type: this.getFileExtension.transform(element.display_file_name),
            };
            attachment_list.push(newElement);
          }
        });
        this.filterConfiguration.push({
          data: attachment_list,
          key: ConfigurationType.TEMPLATE,
          label: 'Attachments',
          placeHolder: 'Search Attachments',
          selectedData: this.linkedTemplate,
          templateConfigurationList: [],
        });
      }

      // this.templateConfigurationList = [];
    } else {
      this.formTypeData = [];
      this.templateConfigurationList.forEach((element, index) => {
        let filterData = res.filter((x) => x.type == element.type);

        let findTemplateType = this.data.template_list.find((x) => x.templateType == element.type);

        let filterList = this.data.template_list.filter((x) => x.templateType == element.type);
        let suggestionFile = [];
        filterData.forEach((filterDataElement) => {
          suggestionFile.push({
            id: filterDataElement.id,
            name: filterDataElement.form_name,
            type: filterDataElement.type,
            profile_image_url: filterDataElement.profile_image_url,
            vault_form_id: filterDataElement.vault_form_id,
            vfid: filterDataElement.id,
          });
        });
        if (filterList.length > 1) {
          filterList.forEach((item) => {
            this.formTypeData.push({
              id: element.id,
              type: element.type,
              image: element.image,
              displayType: item.templateSubType,
              entityData: suggestionFile,
              isCustomImg: true,
              img: element.image,
            });
          });
        } else {
          this.formTypeData.push({
            id: element.id,
            type: element.type,
            image: element.image,
            displayType: findTemplateType.templateSubType,
            entityData: suggestionFile,
            isCustomImg: true,
            img: element.image,
          });
        }
      });
      this.formTypeData.forEach((form) => {
        const matchTemplateExist = this.linkedTemplate.find((template) => template.vault_form_type === form.type);
        form.linked = matchTemplateExist ? true : false;
      });
      this.suggestionData = [
        {
          type: SuggestionType.USER,
          userData: [],
          vaultFormTypeData: [],
        },
        {
          type: SuggestionType.ENTITY,
          userData: [],
          vaultFormTypeData: this.formTypeData,
        },
      ];
      this.is_Group = true;

      this.data.formsList.filter((x) => x.search_tokens != null);
      let list = [];
      if (this.data?.filter_with == 'type_template') {
        list = this.data.formsList.filter((x) => x.type_template?.toLowerCase().includes(this.data?.type_template?.toLowerCase()));
      } else {
        list = this.data.formsList.filter((x) => x.organization_section?.toLowerCase().includes(this.data?.type_template?.toLowerCase()));
      }

      // if (this.data?.vault_folder_type_linked) {
      //   list = [];
      //   this.data.template_list.forEach((element) => {
      //     list = list.concat(this.data.formsList.filter((x) => x.type.toLowerCase() == element.templateType.toLowerCase()));
      //   });
      // }
      this.group_templateConfigurationList = [];
      this.group_templateConfigurationList.push({
        label: this.data.label,
        id: 23,
        img: this.data.icon_path,
        isGroup: true,
        displayType: 'Add New ' + this.data.type_template,
        isCustomImg: true,
        groupList: list,
      });
    }
    this.is_unLinkedFileLoading = false;
    this.cd.detectChanges();
  }

  viewModal(data: { file; event?: any }) {
    let path = data.event.path || (data.event.composedPath && data.event.composedPath());
    if (
      path[1].id !== 'toggleMoreWrapper' &&
      path[1].id !== 'checkbox-input-select' &&
      path[1].id !== 'toggleMore' &&
      path[1].classList[0] !== 'see-more__popup' &&
      path[1].classList[0] !== 'popup__wrapper' &&
      path[2].id !== 'kinnect-avatar' &&
      path[1].classList[0] !== 'share-from-stats' &&
      path[0].classList[0] !== 'share-from-stats' &&
      path[0].classList[0] !== 'not-shared-button' &&
      path[0].classList[0] !== 'checkbox-input' &&
      path[1].classList[0] !== 'mat-checkbox-layout' &&
      path[1].classList[1] !== 'Comment-notes-card'
    ) {
      const dialogOpen = this.dialog.open(AddDocumentComponent, {
        disableClose: true,
        data: { file: data.file, mode: 'edit', isintelligent: false, isfileListLoad: true },
        panelClass: 'full-window-dialog-add-document',
        autoFocus: false,
      });
    }
  }

  editFeedData(item) {
    const childDialog = this.dialog.open(EditMxPlayerComponent, {
      height: '100%',
      autoFocus: false,
      data: {
        selectedFileList: [],
        currentuserId: this.data.currentuserId,
        currentFormId: item.id ? item.id : item.vault_user_form_id,
        hide_checkbox_section: true,
        formName: item.form_name,
      },
      panelClass: 'full-window-dialog',
    });
    this.subscription.add(
      childDialog.afterClosed().subscribe(
        (data) => {
          this.getLinkedForms();
        },
        (error) => {}
      )
    );
  }

  reconnect(item) {
    item.user_id = this.data.currentuserId;
    const dialogRef: MatDialogRef<ConnectToMxComponent> = this.mxTaskbarService.openMxDialog(ConnectToMxComponent, {
      width: '400px',
      maxWidth: this.screenWidth < 480 ? '90vw' : '80vw',
      autoFocus: false,
      data: {
        currentValutUserId: this.data.currentuserId,
        isUpdate: true,
        stop_form_creation: true,
        account: item,
      },
    });
    this.subscription.add(
      dialogRef.afterClosed().subscribe((val) => {
        if (val.success) this.getLinkedForms();
      })
    );
  }

  trackEventsInMixPanel(actionType, linking_type, data: any = null) {
    this._userService
      .trackEventsInMixPanel([{ eventName: EVENTS[`template_linking_${actionType}_${linking_type}`], ...(data && { data: data }) }])
      .then((response) => {});
  }

  scrollToTop() {
    if (this.commonSuggestionViewContainer) {
      this.renderer.setProperty(this.commonSuggestionViewContainer.nativeElement, 'scrollTop', 0);
    }
  }

  closeDialog() {
    if (!this.inlineComponent) {
      if (this.data?.ask_mark_complete && !this.myForm.controls.name.value) {
        const dialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
          width: '386px',
          data: {
            title: 'Mark Complete',
            materialIcon: 'info',
            text: `Do you want to mark ${this.data.label} as complete?`,
            proceedTitle: `Yes`,
            backBUttonTitle: `No`,
            showCancelBtn: true,
          },
        });
        this.subscription.add(
          dialogRef.afterClosed().subscribe((confirmation) => {
            if (confirmation?.confirmation) {
              this.dialogRef.close({
                is_marked: true,
                findItemSetup: this.findItemSetup,
              });
            }
            this.dialogRef.close({
              is_marked: false,
              findItemSetup: this.findItemSetup,
            });
          })
        );
      } else {
        this.dialogRef.close({
          is_marked: this.myForm.controls.name.value || this.linkedTemplate.length > 0,
          findItemSetup: this.findItemSetup,
        });
      }
    }
  }

  clearSelections() {
    if (this.linkedTemplateListComponent) {
      this.linkedTemplateListComponent.clearSelections();
    }
    this.cd.detectChanges();
  }
}
